import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import emailjs from '@emailjs/browser';
import api from '../../api';

const ETAPES_URL = "/parametrages/etapes";
const TICKETS_URL = "/tickets";

const AddTaskForm = ({ onClose }) => {
  const [formData, setFormData] = useState();
  const [nom, setNom] = useState("");
  const [content, setContent] = useState("");
  const [type, setType] = useState("bug");
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(""); // URL de l'image après upload
  const [ModuleId, setModuleId] = useState("");
  const [modules, setModules] = useState([]);
  const [etapes, setEtapes] = useState([]);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isLoading, setIsLoading] = useState(false); // État de chargement
  const [organisation_id, setOrganisation_id] = useState(null);
  const [utilisateur_id, setUtilisateur_id] = useState(null);

    useEffect(() => {
    const fetchUser = async () => {
      try {
        const userResponse = await api.get('/me', { withCredentials: true });
        if (!userResponse.data.success) {
          console.error('Impossible de récupérer les informations utilisateur.');
          return;
        }

        const user = userResponse.data.user;
        setUtilisateur_id(parseInt(user.id, 10));
        setOrganisation_id(parseInt(user.organisation_id, 10));
      } catch (error) {
        console.error('Erreur lors de la récupération des informations utilisateur.');
      }
    };

    fetchUser();
  }, []);




  // Fonction d'upload d'image simplifiée
const uploadToLaravel = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const res = await api.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res.data.url; // URL publique renvoyée par Laravel
};

  // 1) Récupérer les modules de l'organisation
  useEffect(() => {
    if (!organisation_id) return;
    api
      .get(`/organisations/${organisation_id}`)
      .then(({ data }) => {
        setModules(data.organisation.modules || []);
      })
      .catch(err => console.error("Erreur fetch modules:", err));
  }, [organisation_id]);

  // 2) Récupérer la liste des étapes (pour trouver order=1)
  useEffect(() => {
    api
      .get(ETAPES_URL)
      .then(res => {
        setEtapes(res.data.etapes || []);
      })
      .catch(err => console.error("Erreur fetch étapes :", err));
  }, []);

  // Validation de formulaire
  const validateField = (name, value) => {
    let error = "";
    if (name === "nom") {
      if (value.length < 3) error = "Le nom doit contenir au moins 3 caractères";
      else if (value.length > 1000) error = "Le nom ne peut pas dépasser 1000 caractères";
    }
    if (name === "content" && value.length > 1500) {
      error = "La description ne peut pas dépasser 1500 caractères";
    }
    if (name === "ModuleId" && !value) {
      error = "Veuillez sélectionner un module";
    }
    return error;
  };

  // Mettre à jour les erreurs lors du blur
  useEffect(() => {
    const newErr = {};
    Object.keys(touched).forEach(f => {
      const val = { nom, content, ModuleId }[f];
      const e = validateField(f, val);
      if (e) newErr[f] = e;
    });
    setErrors(newErr);
  }, [nom, content, ModuleId, touched]);

  const handleBlur = field => {
    setTouched(prev => ({ ...prev, [field]: true }));
  };

  // Soumission du formulaire
  const handleSubmit = async e => {
    e.preventDefault();

    const finalErrors = {
      nom: validateField("nom", nom),
      content: validateField("content", content),
      ModuleId: validateField("ModuleId", ModuleId),
    };
    setErrors(finalErrors);
    if (Object.values(finalErrors).some(x => x)) return;

    setIsLoading(true);

    try {
      // 1) Upload de l'image si nécessaire
      let uploadedImageUrl = "";
      if (type === "bug" && image) {
        try {
          uploadedImageUrl = await uploadToLaravel(image);
        } catch (uploadErr) {
          console.error("Erreur upload Cloudinary :", uploadErr);
          toast.error("Erreur lors de l'upload de l'image");
          setIsLoading(false);
          return;
        }
      }

      const todayStr = new Date().toISOString().split("T")[0];

      // 2) Préparer les données avec image comme string
      const data = {
        nom,
        content,
        type,
        priorite: 1,
        etape_id: "",
        validation_adminCl: 1,
        last_update: todayStr,
        confirmation_admin: 0,
        accepter: 3,
        status: 1,
        organisation_id,
        createur_id: utilisateur_id,
        module_id: ModuleId,
        image: uploadedImageUrl || "", // ✅ Toujours une string (vide si pas d'image)
      };

      // 3) Envoyer les données
      const response = await api.post(TICKETS_URL, data);
      console.log("Image envoyée au backend :", uploadedImageUrl);
      console.log("Données envoyées :", data);
      console.log("Réponse serveur :", response.data);
      
      toast.success("Ticket créé avec succès !");
      setTimeout(onClose, 500);
      
    } catch (err) {
      console.error("Détail de l'erreur serveur :", err.response?.data);
      toast.error("Erreur serveur : " + (err.response?.data?.message || err.message));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded shadow-2xl w-[90vw] max-w-2xl p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-1 hover:bg-gray-100 rounded-full transition-colors"
          disabled={isLoading}
        >
          ✕
        </button>
        <h2 className="text-xl font-bold mb-4">Nouveau Ticket</h2>
        
        {/* Overlay de chargement */}
        {isLoading && (
          <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10 rounded">
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-terrecuite"></div>
              <p className="mt-2 text-sm text-gray-600">Création du ticket en cours...</p>
            </div>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Nom & Type */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm mb-1">Nom *</label>
              <input
                type="text"
                value={nom}
                onChange={e => setNom(e.target.value)}
                onBlur={() => handleBlur("nom")}
                disabled={isLoading}
                className={`w-full px-3 py-2 border rounded-md text-sm ${
                  errors.nom ? "border-red-500" : "border-gray-300"
                } ${isLoading ? "bg-gray-100 cursor-not-allowed" : ""}`}
              />
              {errors.nom && <p className="text-red-500 text-xs mt-1">{errors.nom}</p>}
            </div>
            <div>
              <label className="block text-sm mb-1">Type *</label>
              <select
                value={type}
                onChange={e => setType(e.target.value)}
                disabled={isLoading}
                className={`w-full px-3 py-2 border border-gray-300 rounded-md text-sm ${
                  isLoading ? "bg-gray-100 cursor-not-allowed" : ""
                }`}
              >
                <option value="bug">Bug</option>
                <option value="demande">Demande</option>
              </select>
            </div>
          </div>
          
          {/* Module */}
          <div>
            <label className="block text-sm mb-1">Module *</label>
            <select
              value={ModuleId}
              onChange={e => setModuleId(e.target.value)}
              onBlur={() => handleBlur("ModuleId")}
              disabled={isLoading}
              className={`w-full px-3 py-2 border rounded-md text-sm ${
                errors.ModuleId ? "border-red-500" : "border-gray-300"
              } ${isLoading ? "bg-gray-100 cursor-not-allowed" : ""}`}
            >
              <option value="">-- Sélectionner un module --</option>
              {modules.map(mod => (
                <option key={mod.id} value={mod.id}>
                  {mod.nom}
                </option>
              ))}
            </select>
            {errors.ModuleId && <p className="text-red-500 text-xs mt-1">{errors.ModuleId}</p>}
          </div>
          
          {/* Description */}
          <div>
            <label className="block text-sm mb-1">Description *</label>
            <textarea
              value={content}
              onChange={e => setContent(e.target.value)}
              onBlur={() => handleBlur("content")}
              rows={3}
              disabled={isLoading}
              className={`w-full px-3 py-2 border rounded-md text-sm ${
                errors.content ? "border-red-500" : "border-gray-300"
              } ${isLoading ? "bg-gray-100 cursor-not-allowed" : ""}`}
            />
            {errors.content && <p className="text-red-500 text-xs mt-1">{errors.content}</p>}
            <div className="text-right text-xs text-gray-500 mt-1">
              {content.length}/1500 caractères
            </div>
          </div>
          
          {/* Upload image pour bug */}
          {type === "bug" && (
            <div>
              <label className="block text-sm mb-1">Capture d'écran</label>
              <label
                className={`flex items-center justify-center w-full border-dashed border-2 border-gray-300 rounded-md p-2 cursor-pointer hover:border-blue-400 ${
                  isLoading ? "bg-gray-100 cursor-not-allowed" : ""
                }`}
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => {
                    if (e.target.files && e.target.files.length > 0) {
                      setImage(e.target.files[0]);
                    }
                  }}
                  disabled={isLoading}
                  className="hidden"
                />
                <span className="text-gray-500">
                  {image ? image.name : "Cliquez pour téléverser une image"}
                </span>
              </label>
            </div>
          )}
          
          {/* Bouton submit */}
          <div className="pt-4 text-center">
            <button
              type="submit"
              className="px-6 py-2 bg-terrecuite hover:bg-terrecuite/90 text-white rounded-md transition-colors disabled:opacity-50 flex items-center justify-center mx-auto min-w-[150px]"
              disabled={Object.values(errors).some(err => err) || isLoading}
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Création...
                </>
              ) : (
                "Créer le Ticket"
              )}
            </button>
          </div>
        </form>
        <ToastContainer position="bottom-right" />
      </div>
    </div>
  );
};

export default AddTaskForm;